import { useTranslation } from 'next-i18next'
import React from 'react'

import { useCardExport } from '../../../contexts/CardExportContext'
import Button from '../button'
import { ExportCardModal } from './ExportCardModal'

const ShareCard = {
  Button: () => {
    const { t } = useTranslation('avaliacao360')
    const { toggleModal } = useCardExport()

    return (
      <Button
        label={t('cards.exportCard')}
        color="white"
        action={toggleModal}
      />
    )
  },

  ButtonHQ: () => {
    const { t } = useTranslation('avaliacao360')
    const { exportCardHQ } = useCardExport()

    return (
      <Button
        label={t('cards.exportCardHQ')}
        color="white"
        action={exportCardHQ}
      />
    )
  },

  Modal: () => {
    const { isModalOpen, toggleModal, shareImage } = useCardExport()

    return (
      <ExportCardModal
        isOpen={isModalOpen}
        onClose={toggleModal}
        onShare={shareImage}
      />
    )
  },
}

export default ShareCard
